/* eslint camelcase: "off" */

import namespace from './utils/namespace'

const item = 'item'
const items = 'items'
const primary = 'primary'
const first = 'first'
const invoke = 'invoke'
const reset = 'reset'
const forget = 'forget'
const get = 'get'
const find = 'find'
const store = 'store'
const update = 'update'
const updates = 'updates'
const destroy = 'destroy'
const merge = 'merge'
const token = 'token'
const read = 'read'
const forgot = 'forgot'
const got = 'got'
const found = 'found'
const stored = 'stored'
const updated = 'updated'
const updatesed = 'updatesed'
const destroyed = 'destroyed'
const merged = 'merged'
const prepend = 'prepend'
const append = 'append'
const invoked = 'invoked'

export const preload = namespace('preload', {
    getters: { item },
    mutations: { forgot, got }
})

export const errors = namespace('errors', {
    getters: { item, items, first },
    actions: { reset, forget, store },
    mutations: { reset, forgot, stored }
})

export const accounts = namespace('accounts', {
    getters: { item, items },
    actions: { reset, forget, find, update },
    mutations: { reset, forgot, found, updated },
    modules: {
        verification: {
            actions: { update }
        }
    }
})

export const alerts = namespace('alerts', {
    getters: { items },
    actions: { reset, forget, get },
    mutations: { reset, forgot, got }
})

export const applicants = namespace('applicants', {
    getters: { item, items },
    actions: { reset, forget, find, update },
    mutations: { reset, forgot, got, found, stored, updated },
    modules: {
        employers: {
            getters: { items },
            actions: { reset, forget, update },
            mutations: { reset, forgot, updated }
        },
        landlords: {
            getters: { item },
            actions: { reset, forget, store },
            mutations: { reset, forgot, stored }
        },
        submission: {
            actions: { store }
        }
    }
})

export const applications = namespace('applications', {
    getters: { item, items },
    actions: { reset, forget, find, get },
    mutations: { reset, forgot, found, got },
    modules: {
        applicants: {
            actions: { get, store, update }
        },
        reject: {
            actions: { invoke }
        }
    }
})

export const auto_payments = namespace('auto_payments', {
    getters: { item },
    actions: { reset, forget, store, destroy },
    mutations: { reset, forgot, found, stored, destroyed }
})

export const bank_accounts = namespace('bank_accounts', {
    getters: { item, items, primary },
    actions: { reset, forget, get, token, store, update, destroy },
    mutations: { reset, forgot, got, stored, updated, destroyed }
})

export const bank_cards = namespace('bank_cards', {
    getters: { item, items },
    actions: { reset, forget, get, find, store, update, destroy },
    mutations: { reset, forgot, got, found, stored, updated, destroyed },
    modules: {
        verify: {
            actions: { invoke }
        }
    }
})

export const blog_posts = namespace('blog_posts', {
    getters: { item, items },
    actions: { reset, forget, get, find },
    mutations: { reset, forgot, got, found }
})

export const businesses = namespace('businesses', {
    getters: { item },
    actions: { reset, forget, find, store },
    mutations: { reset, forgot, found, stored }
})

export const calendar_events = namespace('calendar_events', {
    getters: { item, items },
    actions: { reset, forget, get, find },
    mutations: { reset, forgot, got, found }
})

export const callback_requests = namespace('callback_requests', {
    getters: { item },
    actions: { reset, forget, store },
    mutations: { reset, forgot, stored }
})

export const charges = namespace('charges', {
    getters: { item, items },
    actions: { reset, forget, get, find, store, update, merge },
    mutations: { reset, forgot, got, found, stored, updated, merged },
    modules: {
        acknowledgement: {
            getters: { item },
            actions: { reset, forget, update },
            mutations: { reset, forgot, updated }
        }
    }
})

export const contacts = namespace('contacts', {
    getters: { item, items },
    actions: { reset, forget, get, find, store, update, destroy },
    mutations: { reset, forgot, got, found, stored, updated, destroyed }
})

export const documents = namespace('documents', {
    getters: { item, items },
    actions: { reset, forget, get, find, store, update },
    mutations: { reset, forgot, got, found, stored, updated },
    modules: {
        files: {
            getters: { items },
            actions: { reset, forget, get },
            mutations: { reset, forgot, got }
        }
    }
})

export const email_verifications = namespace('email_verifications', {
    getters: { item },
    actions: { reset, forget, store, update },
    mutations: { reset, forgot, stored, updated }
})

export const fees = namespace('fees', {
    getters: { items, item },
    actions: { reset, forget, get, find, store },
    mutations: { reset, forgot, got, found, stored },
    modules: {
        write_off: {
            getters: { item },
            actions: { reset, forget, store },
            mutations: { reset, forgot, stored }
        }
    }
})

export const identity_documents = namespace('identity_documents', {
    getters: { item },
    actions: { reset, forget, store },
    mutations: { reset, forgot, found, stored }
})

export const inventories = namespace('inventories', {
    getters: { item, items },
    actions: { reset, forget, get, find, store, update },
    mutations: { reset, forgot, got, found, stored, updated },
    modules: {
        files: {
            getters: { items },
            actions: { reset, forget, get },
            mutations: { reset, forgot, got }
        }
    }
})

export const invitations = namespace('invitations', {
    getters: { item },
    actions: { reset, forget, store },
    mutations: { reset, forgot, stored },
    modules: {
        current: {
            getters: { item },
            mutations: { found }
        }
    }
})

export const job_sheets = namespace('job_sheets', {
    getters: { item },
    actions: { reset, forget, find, store },
    mutations: { reset, forgot, found, stored },
    modules: {
        contacts: {
            getters: { item },
            actions: { reset, forget, update },
            mutations: { reset, forgot, updated }
        },
        entries: {
            getters: { item },
            actions: { reset, forget, store },
            mutations: { reset, forgot, stored }
        }
    }
})

export const hints = namespace('hints', {
    getters: { item },
    actions: { reset, forget, store },
    mutations: { reset, forgot, stored }
})

export const landlords = namespace('landlords', {
    getters: { item, items },
    actions: { reset, forget, find, store, update },
    mutations: { reset, forgot, found, stored, updated },
    modules: {
        current: {
            getters: { item },
            actions: { find },
            mutations: { found }
        },
        activation: {
            actions: { update }
        },
        notification_preferences: {
            getters: { items },
            actions: { reset, forget, get, update },
            mutations: { reset, forgot, got, updated }
        }
    }
})

export const listings = namespace('listings', {
    getters: { items, item },
    actions: { reset, forget, get, find, store, update },
    mutations: { reset, forgot, got, found, stored, updated },
    modules: {
        activation: {
            actions: { store, destroy }
        },
        messages: {
            getters: { item },
            actions: { reset, forget, store },
            mutations: { reset, forgot, stored }
        }
    }
})

export const chats = namespace('chats', {
    getters: { items, item },
    actions: { reset, forget, get, find, store, read },
    mutations: { reset, forgot, got, found, stored }
})

export const maintenances = namespace('maintenances', {
    getters: { item, items },
    actions: { reset, forget, get, find, store, update, destroy },
    mutations: { reset, forgot, got, found, stored, updated, destroyed }
})

export const messages = namespace('messages', {
    getters: { items, item },
    actions: { forget, get, store },
    mutations: { forgot, got, stored, prepend, append }
})

export const notes = namespace('notes', {
    getters: { item },
    actions: { reset, forget, store },
    mutations: { reset, forgot, stored }
})

export const notifications = namespace('notifications', {
    getters: { items },
    actions: { reset, forget, get },
    mutations: { reset, forgot, got }
})

export const password_resets = namespace('password_resets', {
    getters: { item },
    actions: { reset, forget, store, update },
    mutations: { reset, forgot, stored, updated }
})

export const payments = namespace('payments', {
    getters: { item },
    actions: { reset, forget, find },
    mutations: { reset, forgot, found }
})

export const payment_intents = namespace('payment_intents', {
    getters: { item, items },
    actions: { reset, forget, get, find, store },
    mutations: { reset, forgot, got, found, stored }
})

export const payouts = namespace('payouts', {
    getters: { item },
    actions: { reset, forget, find },
    mutations: { reset, forgot, found }
})

export const persons = namespace('persons', {
    getters: { item, items },
    actions: { reset, forget, find, update, updates },
    mutations: { reset, forgot, found, updated, updatesed }
})

export const properties = namespace('properties', {
    getters: { item, items },
    actions: { reset, forget, get, find, store, update },
    mutations: { reset, forgot, got, found, stored, updated },
    modules: {
        archive: {
            getters: { item },
            actions: { reset, forget, update },
            mutations: { reset, forgot, updated }
        }
    }
})

export const remarketings = namespace('remarketings', {
    getters: { item },
    actions: { reset, forget, store },
    mutations: { reset, forgot, stored }
})

export const rents = namespace('rents', {
    getters: { items, item },
    actions: { reset, forget, get, find, merge },
    mutations: { reset, forgot, got, found, updated, merged },
    modules: {
        extension: {
            getters: { item },
            actions: { reset, forget, update },
            mutations: { reset, forgot, updated }
        },
        write_off: {
            getters: { item },
            actions: { reset, forget, store },
            mutations: { reset, forgot, stored }
        }
    }
})

export const residencies = namespace('residencies', {
    getters: { item, items },
    actions: { reset, forget, get, find, store },
    mutations: { reset, forgot, got, found, stored },
    modules: {
        accept: {
            getters: { item },
            actions: { reset, forget, store },
            mutations: { reset, forgot, stored }
        },
        invite: {
            getters: { item },
            actions: { reset, forget, invoke },
            mutations: { reset, forgot, invoked }
        },
        current: {
            getters: { item },
            mutations: { found }
        }
    }
})

export const search = namespace('search', {
    getters: { items },
    actions: { reset, forget, get },
    mutations: { reset, forgot, got }
})

export const sessions = namespace('sessions', {
    getters: { item },
    actions: { reset, forget, store },
    mutations: { reset, forgot, stored }
})

export const setup_intents = namespace('setup_intents', {
    getters: { item },
    actions: { reset, forget, store },
    mutations: { reset, forgot, stored }
})

export const subscriptions = namespace('subcriptions', {
    getters: { item, items },
    actions: { reset, forget, get, store, destroy },
    mutations: { reset, forgot, got, stored, destroyed },
    modules: {
        bank_cards: {
            getters: { item },
            actions: { reset, forget, store },
            mutations: { reset, forget, stored }
        },
        cancel: {
            getters: { item },
            actions: { reset, forget, invoke },
            mutations: { reset, forget, invoked }
        },
        reactivate: {
            getters: { item },
            actions: { reset, forget, invoke },
            mutations: { reset, forget, invoked }
        }
    }
})

export const occupants = namespace('occupants', {
    getters: { items, item },
    actions: { reset, forget, get, find, store, update },
    mutations: { reset, forgot, got, found, stored, updated }
})

export const tasks = namespace('tasks', {
    getters: { items, item },
    actions: { reset, forget, find, get, store, update, destroy },
    mutations: { reset, forgot, found, got, stored, updated, destroyed },
    modules: {
        complete: {
            getters: { item },
            actions: { reset, forget, invoke },
            mutations: { reset, forget, invoked }
        }
    }
})

export const tenancies = namespace('tenancies', {
    getters: { items, item },
    actions: { reset, forget, get, find, store, update },
    mutations: { reset, forgot, got, found, stored, updated },
    modules: {
        archive: {
            getters: { item },
            actions: { reset, forget, update },
            mutations: { reset, forgot, updated }
        },
        charges: {
            getters: { item },
            actions: { reset, forget, store },
            mutations: { reset, forgot, stored }
        },
        terminate: {
            getters: { item },
            actions: { reset, forget, update },
            mutations: { reset, forgot, updated }
        }
    }
})

export const tenants = namespace('tenants', {
    getters: { item, items },
    actions: { reset, forget, get, find, store, update },
    mutations: { reset, forgot, got, found, stored, updated },
    modules: {
        current: {
            getters: { item },
            actions: { find },
            mutations: { found }
        },
        notification_preferences: {
            getters: { items },
            actions: { reset, forget, get, update },
            mutations: { reset, forgot, got, updated }
        }
    }
})

export const transactions = namespace('transactions', {
    getters: { item, items },
    actions: { reset, forget, get, find },
    mutations: { reset, forgot, got, found }
})

export const transfers = namespace('transfers', {
    getters: { item },
    actions: { reset, forget, find },
    mutations: { reset, forgot, found }
})

export const users = namespace('users', {
    getters: { item },
    actions: { reset, forget, find, store, update },
    mutations: { reset, forgot, found, stored, updated },
    modules: {
        charges: {
            getters: { items },
            actions: { reset, forget, get },
            mutations: { reset, forgot, got }
        },
        current: {
            getters: { item },
            actions: { find, merge },
            mutations: { found, merged }
        },
        password: {
            actions: { update }
        },
        subscription: {
            getters: { item },
            actions: { reset, forget, invoke },
            mutations: { reset, forgot, invoked }
        }
    }
})
